import { UserContext } from "@/contexts/SessionContext"
import { LogoutOutlined, UserOutlined } from "@ant-design/icons"
import { useMutation } from "@apollo/client"
import { Dropdown, Menu } from "antd"
import { MenuInfo } from "rc-menu/lib/interface"
import React, { useContext } from "react"
import styles from "./PHHeaderDropdown.module.less"
import { LOGOUT } from "./PHHeaderDropdown.graphql"

export const PHHeaderDropdown = () => {
  const { session } = useContext(UserContext)
  const [logout] = useMutation(LOGOUT)

  const onMenuClick = async ({ key }: MenuInfo) => {
    switch (key) {
      case "logout": {
        await logout()
        const origin = window.location.origin
        const noRedirectUrlConditions = ["redirect", "requestPassword", "resetPassword", "login"]
        if (noRedirectUrlConditions.some((condition) => window.location.href.includes(condition))) {
          return
        }

        window.location.href = `${origin}/login?redirect=${window.location.href}`
        break
      }
      default:
        break
    }
  }

  const menu = (
    <Menu onClick={onMenuClick}>
      <Menu.Item key="logout">
        <LogoutOutlined />
        Logout
      </Menu.Item>
    </Menu>
  )
  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <span className={styles["current-user"]}>
        <UserOutlined /> {session?.user?.firstname} {session?.user?.lastname}
      </span>
    </Dropdown>
  )
}
